import { render, staticRenderFns } from "./Twilio.vue?vue&type=template&id=07350cf5&scoped=true&"
import script from "./Twilio.vue?vue&type=script&lang=js&"
export * from "./Twilio.vue?vue&type=script&lang=js&"
import style0 from "./Twilio.vue?vue&type=style&index=0&id=07350cf5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07350cf5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/danford/drochat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07350cf5')) {
      api.createRecord('07350cf5', component.options)
    } else {
      api.reload('07350cf5', component.options)
    }
    module.hot.accept("./Twilio.vue?vue&type=template&id=07350cf5&scoped=true&", function () {
      api.rerender('07350cf5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/channels/Twilio.vue"
export default component.exports